import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import { RootState } from '../../@types/RootState';

export const channelsConfigSchema = z.object({
  wholesale: z.object({
    enabled: z.boolean(),
    allowPriceEdit: z.boolean(),
    allowTriggerEdit: z.boolean(),
    allowPriceRound: z.boolean(),
  }),
  offer: z.object({
    enabled: z.boolean(),
    allowPriceEdit: z.boolean(),
    allowCreateRule: z.boolean(),
  }),
});

export type ChannelsConfigSchema = z.infer<typeof channelsConfigSchema>;

export const initialState: ChannelsConfigSchema = {
  offer: {
    enabled: false,
    allowCreateRule: false,
    allowPriceEdit: false,
  },
  wholesale: {
    enabled: false,
    allowPriceEdit: false,
    allowTriggerEdit: false,
    allowPriceRound: false,
  },
};

const slice = createSlice({
  name: 'ipa.setup.channels',
  initialState,
  reducers: {
    SET_SETUP_IPA_CHANNELS: (_state, action: PayloadAction<ChannelsConfigSchema>) => {
      return action.payload;
    },
  },
});

export const selectorSetupIpaChannels = (state: RootState) => {
  return state.reducerIPA.channels;
};

export const selectorIsWholesaleEnabled = (state: RootState) => {
  return state.reducerIPA.channels.wholesale.enabled;
};

export const { SET_SETUP_IPA_CHANNELS } = slice.actions;

export default slice.reducer;
